// imports all Phosphor icons so any icon an admin picks from the catalog works in the sidebar
import { type IconType } from 'react-icons';
import * as PiIcons from 'react-icons/pi';

const PRACTICE_ICON_MAP = PiIcons as Record<string, IconType>;

export function resolvePracticeIcon(name: string): IconType | null {
  return PRACTICE_ICON_MAP[name] || null;
}

export default PRACTICE_ICON_MAP;
